module.exports = __webpack_public_path__ + "assets/img/74422f1bfcf00aa07366bbf98f6ad4f0.png";